import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

export function WalletWarningBanner(): ReactNode {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();

  if (!user) return null;
  if (user.role !== 'collector') return null;
  if (user.account_status !== 'healthy') return null;
  if (user.usdc_wallet?.trim()) return null;

  return (
    <div className="flex items-center justify-between gap-sm rounded-lg border border-brand-red/40 bg-brand-red/10 py-sm pl-base pr-sm backdrop-blur-xl">
      <span className="text-[11px] text-brand-red sm:text-sm">
        Configura tu billetera para poder recibir tus pagos
      </span>
      <button
        onClick={() => navigate('/wallet')}
        className="shrink-0 rounded-md bg-brand-red/20 px-sm py-1 text-[11px] font-semibold text-brand-red transition-colors hover:bg-brand-red/30 sm:text-xs"
      >
        Configurar ahora
      </button>
    </div>
  );
}
